import React from "react";
import { Helmet } from "react-helmet-async";

export default function SEO({ title, description, path = "", noindex = false, image = null }) {
  const baseUrl = process.env.REACT_APP_BASE_URL || "https://billforge.codingwithdevam.cloud";
  const fullUrl = `${baseUrl}${path}`;
  const defaultTitle = "Bill Forge - Simple, Powerful Invoicing";
  const defaultDescription =
    "Create professional invoices, manage customers, track inventory, and grow your business with Bill Forge. Multi-organization support, custom templates, and more.";
  const defaultImage = `${baseUrl}/logo.svg`;

  return (
    <Helmet>
      <title>{title ? `${title} | Bill Forge` : defaultTitle}</title>
      <meta name="description" content={description || defaultDescription} />
      <link rel="canonical" href={fullUrl} />
      
      {noindex && <meta name="robots" content="noindex, nofollow" />}
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:title" content={title ? `${title} | Bill Forge` : defaultTitle} />
      <meta
        property="og:description"
        content={description || defaultDescription}
      />
      <meta property="og:image" content={image || defaultImage} />
      <meta property="og:image:alt" content="Bill Forge Logo" />
      <meta property="og:site_name" content="Bill Forge" />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={fullUrl} />
      <meta name="twitter:title" content={title ? `${title} | Bill Forge` : defaultTitle} />
      <meta
        name="twitter:description"
        content={description || defaultDescription}
      />
      <meta name="twitter:image" content={image || defaultImage} />
      <meta name="twitter:image:alt" content="Bill Forge Logo" />
    </Helmet>
  );
}
